import React from 'react'
import { Column } from 'primereact/column'
import InputTextEditor from './InputTextEditor'
import IdaFilterTemplate from '../Filters/IdaFilterTemplate'
import { createFieldChangedChecker } from '../utils/createFieldChangedChecker'

const IdaCodeColumn = ({ title, mapsToField, filter, sortable, editable, isFieldChanged, isFieldChangedOverride, validationErrors, template, originalData }) => {
    const filterAttributes = {
        filter,
        filterPlaceholder: `Search by  ${title}`,
        required: !!filter,
        disabled: !filter
    }
    const sortAttributes = {
        sortable,
        required: !!sortable,
        disabled: !sortable
    }

    const checkFieldChanged = createFieldChangedChecker({
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            dataType="text"
            body={(rowData) => (
                <span className={checkFieldChanged(rowData) ? 'changed-field' : ''}>
                    {rowData[mapsToField] ? (template ? template(rowData) : rowData[mapsToField]) : rowData[mapsToField]}
                </span>
            )}
            editor={editable ? (options) => <InputTextEditor options={options} validationErrors={validationErrors} /> : null}
            filterElement={(options) => <IdaFilterTemplate options={options} field={mapsToField} />}
            {...filterAttributes}/>
    )
}

export default IdaCodeColumn
